export default __webpack_public_path__ + "4b5e1522fab9b53dbbff750a099b9214.png";